import { useEffect, useState } from "react";
import {
  codigosRespuesta,
  IResponseApiFluent,
} from "../../../../interfaces/base/IResponse";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import {
  ICrearLugarMovilizacionHorarioCommand,
  IListarLugarMovilizacionHorarioDto,
} from "../../../../interfaces/ILugarMovilizacionHorario";
import { LugarMovilizacionService } from "../../../../services/movilizacion/LugarMovilizacionService";
import { _formatTime } from "../../../../utils/Helper/datetimeHelper";

const useLugarMovilizacionHorario = (
  props: IOpenPanel & {
    dataEdit: IListarLugarMovilizacionHorarioDto;
    setDataEdit: (data: IListarLugarMovilizacionHorarioDto) => void;
  }
) => {
  const initial: ICrearLugarMovilizacionHorarioCommand = {
    actividad: 1,
    comentario: "",
    guardiaProgramacionId: "",
    lugarMovilizacionId: "",
    horarioEmbarque: null,
    horarioSalida: null,
  };

  const [command, setCommand] =
    useState<ICrearLugarMovilizacionHorarioCommand>(initial);
  const [disableForm, setDisableForm] = useState<boolean>(true);
  const [status, setStatus] = useState<codigosRespuesta>(0);
  const [mensaje, setMensaje] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonSalir, setButtonSalir] = useState<boolean>(false);

  const postCrearLugarMovilizacionHorario = () => {
    setLoading(true);

    command.horarioEmbarque = command.horarioEmbarque ? _formatTime(command.horarioEmbarque ?? "") : null;
    command.horarioSalida = command.horarioSalida ? _formatTime(command.horarioSalida ?? "") : null;

    if (command.guardiaProgramacionId == "0" || command.guardiaProgramacionId == "") {
      delete command.guardiaProgramacionId;
    }

    LugarMovilizacionService.CrearLugarMovilizacionHorario(command)
      .then((res) => {
        if (res.status == 200) {
          setStatus(200);
          setMensaje(res.data.mensaje);
          setTimeout(() => {
            props.reload?.();
            cerrarPanel();
          }, 3000);
        } else {
          setStatus(500);
        }
      })
      .catch((e) => {
        if (
          e.response?.data &&
          "type" in e.response.data &&
          "title" in e.response.data &&
          "status" in e.response.data &&
          "instance" in e.response.data &&
          "errors" in e.response.data
        ) {
          const errorResponse = e.response.data as IResponseApiFluent;
          const mensajeError = errorResponse.errors.join("\n");
          setButtonSalir(true);
          setMensaje(mensajeError);
        } else {
          setMensaje("Error Inesperado");
        }
        setStatus(500);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const putEditarLugarMovilizacionHorario = () => {
    setLoading(true);

    command.horarioEmbarque = _formatTime(command.horarioEmbarque ?? "");
    command.horarioSalida = _formatTime(command.horarioSalida ?? "");

    if (command.guardiaProgramacionId == "0" || command.guardiaProgramacionId == "") {
      delete command.guardiaProgramacionId;
    }

    LugarMovilizacionService.EditarLugarMovilizacionHorario({
      lugarMovilizacionHorarioId: props.dataEdit.lugarMovilizacionHorarioId,
      ...command,
    })
      .then((res) => {
        if (res.status == 200) {
          setStatus(200);
          setMensaje(res.data.mensaje);
          setTimeout(() => {
            props.reload?.();
            cerrarPanel();
          }, 3000);
        } else {
          setStatus(500);
        }
      })
      .catch((e) => {
        if (
          e.response?.data &&
          "type" in e.response.data &&
          "title" in e.response.data &&
          "status" in e.response.data &&
          "instance" in e.response.data &&
          "errors" in e.response.data
        ) {
          const errorResponse = e.response.data as IResponseApiFluent;
          const mensajeError = errorResponse.errors.join("\n");
          setButtonSalir(true);
          setMensaje(mensajeError);
        } else {
          setMensaje("Error Inesperado");
        }
        setStatus(500);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const cerrarPanel = () => {
    setMensaje("");
    setCommand(initial);
    setStatus(0);
    props.onDismiss();
  };

  let required: (keyof ICrearLugarMovilizacionHorarioCommand)[] = [
    "actividad",
    "lugarMovilizacionId",
  ];

  useEffect(() => {
    const check = required.every((field) => {
      const value = command[field];
      return value !== null && value !== undefined && value !== "";
    });
    setDisableForm(!check);
  }, [command]);

  useEffect(() => {
    setCommand({
      actividad: props.dataEdit?.actividad ?? 1,
      comentario: props.dataEdit?.comentario ?? "",
      guardiaProgramacionId: props.dataEdit?.guardiaProgramacionId ?? "",
      lugarMovilizacionId: props.dataEdit?.lugarMovilizacionId ?? "",
      horarioEmbarque: props.dataEdit?.horarioEmbarque ?? "",
      horarioSalida: props.dataEdit?.horarioSalida ?? "",
    });
  }, [props.dataEdit]);

  return {
    command,
    setCommand,
    postCrearLugarMovilizacionHorario,
    putEditarLugarMovilizacionHorario,
    loading,
    setLoading,
    disableForm,
    cerrarPanel,
    mensaje,
    setMensaje,
    status,
    buttonSalir,
  };
};

export { useLugarMovilizacionHorario };
